module.exports = __webpack_public_path__ + "static/media/facebook_logo.8d27295c.svg";